function Unauthorized() {
  return (
    <div className="min-h-screen bg-salon-bg flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md text-center">
        <div className="flex justify-center mb-4">
          <img src="/images/logo-grey.png" alt="Muse & Mane" className="h-16" />
        </div>
        <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>
        <p className="text-gray-600 mb-6">
          You do not have permission to view this page.
        </p>
        <button
          onClick={() => window.location.href = '/login'}
          className="bg-salon-button text-white px-6 py-2 rounded-md hover:bg-salon-button-hover"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}

export default Unauthorized;
